<template>
  <fragment>
    <div id="licence-list">
      <h3>Licence</h3>
      <div class="alert alert-warning"
           role="alert"
           v-if="getCompanyLicenceList.length === 0">
        No licence available
      </div>

      <table class="table" v-if="getCompanyLicenceList.length > 0">
        <thead>
          <tr>
            <th scope="col">Licence Type</th>
            <th scope="col">Issued By</th>
            <th scope="col">Expiration Date</th>
            <th scope="col" style="width: 100px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="companyLicence in getCompanyLicenceList" :key="companyLicence.id">
            <td width="300">{{ companyLicence.licence.type }}</td>
            <td width="300">{{ companyLicence.issuedBy }}</td>
            <td width="300">{{ companyLicence.expirationDate | datetime }}</td> <!-- Format Date-->
            <td>
              <a role="button"
                 href="#"
                 class="d-flex justify-content-between align-items-center flex-column"
                 title="Manage"
                 @click.prevent="editLicence(companyLicence.id)">
                <img class="mb-1" src="@/assets/document.svg" alt />
                <span class="small-grey">Manage</span>
              </a>
            </td>
            <td>
              <a role="button"
                 href="#"
                 class="d-flex justify-content-between align-items-center flex-column"
                 title="Delete"
                 @click.prevent="deleteLicence(companyLicence.id)">
                <img class="mb-1" src="@/assets/document.svg" alt />
                <span class="small-grey">Remove</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row mb-3">
        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-primary" @click="newLicence">
            <i class="fas fa-plus"></i>
            Add New Licence
          </button>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-company-licence"
             size="lg"
             hide-header
             hide-footer
             :no-close-on-backdrop="true">
      <company-licence />
    </b-modal>
  </fragment>
</template>

<script>
  import CompanyLicence from "@/views/company/components/company-licence.vue";
  import { mapGetters, mapActions } from "vuex";
  import MessageBox from "@/utils/messagebox";
  import Toast from "@/utils/toast";

  export default {
    name: "company-licence-information",
    components: { CompanyLicence },
    computed: {
      ...mapGetters(["getCompanyLicenceList"])
    },
    methods: {
      newLicence() {
        this.resetCompanyLicence().then(() => {
          this.$bvModal.show("bv-modal-company-licence");
        });
      },
      editLicence(id) {
        this.fetchCompanyLicence(id).then(() => {
          this.$bvModal.show("bv-modal-company-licence");
        });
      },
      async deleteLicence(id) {
        let confirm = await MessageBox.confirm(
          this,
          "Remove Licence",
          "Are you sure you want to remove this licence?"
        );

        if (confirm) {
          this.removeCompanyLicence(id).then(() => {
            Toast.success(this, "Successfully removed licence!");
          });
        }
      },
      ...mapActions([
        "fetchCompanyLicence",
        "resetCompanyLicence",
        "removeCompanyLicence"
      ])
    }
  };
</script>
